import { effect, Signal, WritableSignal } from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';

export function setupConditionalRequiredValidation(
  form: FormGroup,
  conditionalSignal: WritableSignal<boolean>,
  conditionalFields: string[] | null,
  triggerFields: string[]
): void {
  const updateConditionalValidation = () => {
    const shouldRequire = triggerFields.some((field) => form.get(field)?.value === 'Sí');
    conditionalSignal.set(shouldRequire);
    conditionalFields?.forEach((field) => {
      const control = form.get(field);
      if (shouldRequire) {
        control?.addValidators(Validators.required);
        control?.markAsTouched();
      } else {
        control?.removeValidators(Validators.required);
      }
      control?.updateValueAndValidity({ emitEvent: false });
    });
  };

  triggerFields.forEach((field) => {
    form.get(field)?.valueChanges.subscribe(() => {
      updateConditionalValidation();
    });
  });

  updateConditionalValidation();
}

export function forceAtLeastOneFieldFilled(
  form: FormGroup,
  conditionalSignal: Signal<boolean>,
  confirmSignal: WritableSignal<boolean>,
  checkedFields: string[]
): void {
  const allFieldsRequired = () => {
    checkedFields?.forEach((field) => {
      const control = form.get(field);
      if (conditionalSignal()) {
        control?.addValidators(Validators.required);
      } else {
        control?.removeValidators(Validators.required);
      }
      control?.updateValueAndValidity({ emitEvent: false });
    });

    const atLeastOneFilled = checkedFields.some((field) => {
      const value = form.get(field)?.value;
      return value !== null && value !== undefined && value !== '';
    });

    confirmSignal.set(atLeastOneFilled);

    if (atLeastOneFilled) {
      checkedFields.forEach((field) => {
        const control = form.get(field);
        control?.clearValidators();
        control?.updateValueAndValidity({ emitEvent: false });
      });
    }
  };

  checkedFields.forEach((field) => {
    form.get(field)?.valueChanges.subscribe(() => {
      allFieldsRequired();
    });
  });

  effect(() => {
    conditionalSignal();
    allFieldsRequired();
  });
}

export function setupRequiredValidationBySignal(
  form: FormGroup,
  conditionalSignal: Signal<boolean>,
  requiredFields: string[]
): void {
  effect(() => {
    const shouldRequire = conditionalSignal();

    requiredFields.forEach((field) => {
      const control = form.get(field);
      if (shouldRequire) {
        control?.addValidators(Validators.required);
      } else {
        control?.removeValidators(Validators.required);
      }
      control?.updateValueAndValidity({ emitEvent: false });
    });
  });
}
